<template>
  <v-container class="text-center mt-10">
    <!-- Stato: caricamento -->
    <div v-if="loading" class="my-10">
      <v-progress-circular indeterminate color="primary" size="80"></v-progress-circular>
      <h3 class="mt-6">Aggiornamento in corso...</h3>
    </div>

    <!-- Stato: errore -->
    <div v-else-if="error" class="my-10">
      <v-icon color="red" size="80">mdi-alert-circle</v-icon>
      <h2 class="mt-4">Errore durante la cancellazione</h2>
      <p class="grey--text">{{ error }}</p>
      <v-btn color="primary" class="mt-4" to="/abbonamento">Torna alla pagina abbonamento</v-btn>
    </div>

    <!-- Stato: successo -->
    <div v-else class="my-10">
      <v-icon color="red" size="80">mdi-close-circle</v-icon>
      <h2 class="mt-4">Pagamento annullato</h2>
      <p>Nessun importo è stato addebitato.</p>

      <v-card class="mx-auto mt-6 pa-4" max-width="400" outlined>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold">
              Sessione annullata
            </v-list-item-title>
            <v-list-item-subtitle v-if="sessionId">ID: {{ sessionId }}</v-list-item-subtitle>
            <v-list-item-subtitle>Stato aggiornato nel sistema ✅</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-card>

      <v-btn color="primary" class="mt-6" to="/abbonamento">
        Torna alla pagina abbonamento
      </v-btn>

      <p class="grey--text text--darken-1 mt-3">
        Verrai reindirizzato automaticamente tra {{ redirectCountdown }} secondi...
      </p>
    </div>
  </v-container>
</template>

<script>
import axios from "@/api/axios";

export default {
  name: "AbbonamentoCancel",
  data() {
    return {
      loading: true,
      error: null,
      sessionId: null,
      redirectCountdown: 6,
    };
  },
  methods: {
    async cancellaPagamento(sessionId) {
      try {
        await axios.get(`/payments/cancel?session_id=${sessionId}`);
      } catch (err) {
        console.error(err);
        this.error = "Errore durante l'aggiornamento dello stato del pagamento.";
      } finally {
        this.loading = false;
      }
    },
    startRedirectTimer() {
      const timer = setInterval(() => {
        if (this.redirectCountdown > 0) this.redirectCountdown--;
        else {
          clearInterval(timer);
          this.$router.push("/abbonamento");
        }
      }, 1000);
    },
  },
  async mounted() {
    this.$store.dispatch("auth/autoLogin");

    this.sessionId = this.$route.query.session_id;
    if (!this.sessionId) {
      this.error = "Sessione non valida o mancante.";
      this.loading = false;
      return;
    }

    await this.cancellaPagamento(this.sessionId);

    if (!this.error) {
      this.startRedirectTimer();
    }
  },
};
</script>

<style scoped>
.v-icon {
  font-size: 80px;
}
</style>
